/**
 * Преобразовать дату к формату "ДД.ММ.ГГГГ"
 * Если строковая дата не валидна/не корректна, то возвращается пустая строка
 *
 * @param dateString - Дата.
 * @returns Строка даты или пустая строка.
 */
export const toDate = (dateString: string): string => {
  if (Number.isNaN(Date.parse(dateString))) {
    return '';
  }

  const date = new Date(dateString);

  return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}.${date.getFullYear()}`;
};

/**
 * Преобразовать дату к формату "27 февраля 2025 13:53"
 * Если строковая дата не валидна/не корректна, то возвращается текущая дата
 *
 * @param date - Дата.
 * @returns Строка даты с месяцем в именительном падеже.
 */
export const toDateDeclensionMonth = (date?: string) => {
  return new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
    .format(date ? new Date(date) : new Date())
    .replace(' г. в', '');
};
